import React from 'react';
import './Home.css';
import Header from '../Components/Layout/Header';
import collage1 from '../Assets/Images/Frame 85.png';
import Button from '../Components/Comman/Button';
import Preloader from '../Components/Comman/Preloader';
import Collage2 from '../Assets/Images/Colllage2.png';
import Card1 from '../Components/Comman/Card';
import Icon1 from '../Assets/Images/Icon1.svg'
import Icon2 from '../Assets/Images/Icon2.svg'
import Icon3 from '../Assets/Images/Icon3.svg'
import MobileImg from '../Assets/Images/not responsive page.png';
import Footer from '../Components/Layout/Footer';
import Timeline from '../Assets/Images/timeline.png';
import Collage3 from '../Assets/Images/Collage 3.png';

const MobileBlock = () => (
  <div className="mobile-block">
    <div className="mobile-block__content">
      <img src={MobileImg} alt="desktop only" className="mobile-block__img" />
    </div>
  </div>
);

const Home = () => {
    return ( 
        <>
          <Preloader />
          <div className="desktop-only">
            <Header/>
            <main>
              <section className="hero">
                <img className='hero_img' src={collage1} alt="" />
                <div className='hero_div1'>
                  <h1>أديب الحارة المصرية</h1>
                  <h3>ستطاع نجيب محفوظ أن يحوّل تفاصيل الحياة اليومية في القاهرة إلى أعمال أدبية خالدة تُقرأ في جميع أنحاء العالم</h3>
                  <Button text="اكتشف رحلته الأدبية"/>
                </div>
              </section>   
              <section className='section2'>
                <div className='section2_div1'>
                  <div className='section2_div3'>
                    <h1>من هو نجيب محفوظ ؟؟</h1>
                    <h3>وُلِد نجيب محفوظ في القاهرة عام 1911، ويُعد من أبرز الروائيين العرب في القرن العشرين. كتب عشرات الروايات والقصص القصيرة التي تناولت حياة المجتمع المصري وقضاياه الاجتماعية والفلسفية.
                      كانت القاهرة مصدر الإلهام الرئيسي في أعمال نجيب محفوظ. فقد جسّد في رواياته تفاصيل الحياة في الأزقة والحارات الشعبية والمقاهي القديمة.
                      من خلال كتاباته، أصبحت القاهرة ليست مجرد مكان، بل شخصية حية تعكس حياة المجتمع المصري وتحولاته. تميز أسلوبه بالواقعية العميقة، حيث جسّد الحياة اليومية في الحارة المصرية وشخصياتها المختلفة.</h3>
                  </div>
                  <img className='section2_img' src={Collage2} alt="" />
                </div>
                <div className='section2_div2'>
                  <Card1 title="عدد الأعمال" icon={Icon1} subtitle="اكثر من 50 عملاً أدبيًا "/>
                  <Card1 title="جائزة نوبل" icon={Icon2} subtitle=" عام 1988 "/>
                  <Card1 title="ترجمت اعماله" icon={Icon3} subtitle="إلى أكثر من 30 لغة"/>
                </div>
              </section>
              <section className='section3'>
    <img
    className='section3_img'
    src={Timeline}
    alt=""
    onMouseEnter={e => e.currentTarget.style.animation = 'slideIn 1.2s ease forwards'} />
    </section>
                  <section className='section2'>
                <div className='section2_div1'>
                  <div className='section2_div3'>
                    <h1>من أقوال نجيب محفوظ</h1>
                  <h3>هناك أموات لم تمت كلماتهم وهناك أحياء لم نسمع لهم صوتا </h3>
                  </div>
                  <img className='section4_img' src={Collage3} alt="" />
                </div>
              </section>
            </main>
          </div>
          <Footer/>
          <MobileBlock />
        </>
     );
}
 
export default Home;